import { addActionInQueue, COACHING_ACTION, getActionsQueue, removeActionFromQueue } from "util/ActionsQueueManager";
import {
    FETCH_ERROR,
    FETCH_SUCCESS,
    SIGNOUT_USER_SUCCESS,
    ERROR_OTHERS,

    FETCH_UNIT_COACHINGS_START,
    COACHINGS_DATA,

    ADD_COMMON_TASK_COACHING_START,
    ADD_COMMON_TASK_COACHING_SUCCESS,
    CURRENT_ACTIONS_QUEUE_DATA



} from "../../constants/ActionsTypes";
import axios from 'util/Api';
import { saveQueue } from "./ActionsQueue";
import { getUnitCoachings, saveUnitCoachings } from "util/LocalDataManager";

export const fetchCoachings = (unitId) => {
    return (dispatch) => {
        dispatch({ type: FETCH_UNIT_COACHINGS_START });
        axios.get('/coachings', {
            params: {
                unitId: unitId
            },
            timeout: 5000,
        })
            .then(({ data }) => {
                if (data.result) {
                    dispatch({ type: FETCH_SUCCESS });
                    saveUnitCoachings(unitId, data.result.coachings); // Save coachings to local storage
                    dispatch({ type: COACHINGS_DATA, payload: data.result.coachings });
                } else {
                    console.log("payload: data.error", data.error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                }
            }).catch(function (error) {
                if (!error.response) {
                    // Request timed out
                    console.log("payload: data.error", error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                    const localCoachings = getUnitCoachings(unitId); // Fallback to local data
                    if (localCoachings.length > 0) {
                        dispatch({ type: COACHINGS_DATA, payload: localCoachings });
                        dispatch({ type: FETCH_SUCCESS });
                    }
                } else if (error.response.status === 401) {
                    localStorage.removeItem("tokenPwa");
                    localStorage.removeItem("user");
                    dispatch({ type: SIGNOUT_USER_SUCCESS });
                } else {
                    dispatch({ type: ERROR_OTHERS, payload: error });
                }
                dispatch({ type: FETCH_ERROR, payload: error.message });
                console.log("Error****:", error.message);
            });
    }
};

export const addcommontaskCoaching = (coachings, paramTime) => {
    // Time param is given when we save actions from queue
    return async (dispatch) => {
        const params = {
            ...coachings
        };
        const time = paramTime || new Date()

        if (!paramTime) {
            await dispatch(saveQueue());
            if (getActionsQueue().length > 0) {
                // There is still a network error
                const nbActions = addActionInQueue(COACHING_ACTION, params, time);
                dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                return;
            }
        }


        dispatch({ type: ADD_COMMON_TASK_COACHING_START });
        return axios.post('/addcommontaskCoaching', params, {
            timeout: 5000,
        })
            .then(({ data }) => {
                if (data.result) {
                    if (paramTime) {
                        const nbActions = removeActionFromQueue(COACHING_ACTION, time);
                        dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                    }
                    dispatch({ type: ADD_COMMON_TASK_COACHING_SUCCESS});
                } else {
                    console.log("payload: data.error", data.error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                }
            }).catch(function (error) {
                if (!error.response) {
                    // Request timed out
                    console.log("payload: data.error", error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                    dispatch({ type: ADD_COMMON_TASK_COACHING_SUCCESS });
                    if (!paramTime) {
                        const nbActions = addActionInQueue(COACHING_ACTION, params, time);
                        dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                    } else {
                        throw new Error("Network Error");
                    }
                } else if (error.response.status === 401) {
                    localStorage.removeItem("tokenPwa");
                    localStorage.removeItem("user");
                    dispatch({type: SIGNOUT_USER_SUCCESS});
                } else {
                    dispatch({ type: ERROR_OTHERS, payload: error });
                }
                dispatch({ type: FETCH_ERROR, payload: error.message });
                console.log("Error****:", error.message);
            });
    }
};


